import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import PropTypes from "prop-types";
import { formatearFecha, porcentaje, metricasPropTypes, COLOR_EAD, COLOR_RAD } from "./efectividadUtils.js";

/**
 * Evolucion por dia del historial de a_graficas_efectividad: una columna de EAD y una
 * de Recolecciones por fecha. Sirve para el global (todas las sucursales) o para una
 * sola sucursal; el tooltip muestra numerador y denominador de cada dia.
 */
function GraficaEfectividadHistorial(props) {
  const filas = props.filas || [];

  if (filas.length === 0) {
    return (
      <p style={{ textAlign: "center", color: "#999", padding: 24 }}>
        Sin historial todavía: se acumula un día por cada corrida del cron de indicadores.
      </p>
    );
  }

  const options = {
    chart: { type: "column", height: 300 },
    title: { text: props.titulo || "Evolución diaria" },
    subtitle: {
      text: "Del " + formatearFecha(filas[0].fecha) + " al " + formatearFecha(filas[filas.length - 1].fecha) +
        " · " + filas.length + (filas.length === 1 ? " día" : " días") + " en el historial"
    },
    xAxis: { categories: filas.map((f) => formatearFecha(f.fecha)), crosshair: true },
    yAxis: { min: 0, max: 100, title: { text: "Efectividad %" } },
    legend: { enabled: true },
    credits: { enabled: false },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const f = filas[this.points[0].point.index];
        if (!f) {
          return false;
        }
        let html = "<b>" + formatearFecha(f.fecha) + "</b><br/>";
        html += '<span style="color:' + COLOR_EAD + '">&#9679;</span> EAD: <b>' + porcentaje(f.ead) + "</b>";
        html += f.ead_total !== null
          ? " (" + f.ead_atiempo + " a tiempo de " + f.ead_total + " guías)<br/>"
          : " (sin guías)<br/>";
        html += '<span style="color:' + COLOR_RAD + '">&#9679;</span> Recolecciones: <b>' + porcentaje(f.rad) + "</b>";
        html += f.rec_total !== null
          ? " (" + f.rec_realizadas + " realizadas de " + f.rec_total + ")"
          : " (sin recolecciones)";
        return html;
      }
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        dataLabels: { enabled: true, format: "{point.y:.0f}", style: { fontSize: "9px", fontWeight: "normal" } }
      }
    },
    series: [
      { name: "EAD (entregas a tiempo)", color: COLOR_EAD, data: filas.map((f) => f.ead) },
      { name: "Recolecciones realizadas", color: COLOR_RAD, data: filas.map((f) => f.rad) }
    ]
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}

GraficaEfectividadHistorial.propTypes = {
  titulo: PropTypes.string,
  filas: PropTypes.arrayOf(
    PropTypes.shape({
      fecha: PropTypes.string,
      ...metricasPropTypes
    })
  )
};

export default GraficaEfectividadHistorial;
